var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "1000px",
        persistent: "",
        "content-class": "user-select-dialog sb-modal"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(data) {
            return [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    top: "",
                    disabled: _vm.disabled
                      ? !_vm.enableTooltip
                      : !_vm.buttonTooltip
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attr = ref.attr
                          return [
                            _vm.assetReview
                              ? _c("delete-confirm-modal", {
                                  attrs: {
                                    title: "",
                                    "header-title": "Ownership Denied",
                                    "button-class":
                                      "error--text sb_btn_solid sb_btn_text",
                                    "button-id": "deleteMethod",
                                    "button-text": "Deny",
                                    "button-icon": "cancel",
                                    "confirm-button-text": "Yes",
                                    "cancel-button-text": "No",
                                    "custom-text":
                                      "You’re denying the ownership of this asset. Do you know who the correct owner is?"
                                  },
                                  on: {
                                    confirm: _vm.openDialog,
                                    cancel: function($event) {
                                      return _vm.confirm([])
                                    }
                                  }
                                })
                              : _c(
                                  "span",
                                  _vm._g({}, on),
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._b(
                                        {
                                          class: _vm.buttonClass,
                                          attrs: {
                                            id: _vm.buttonId,
                                            color: _vm.buttonColor,
                                            small:
                                              _vm.smallButton ||
                                              (!_vm.hasButtonText &&
                                                _vm.hasButtonIcon),
                                            fab:
                                              !_vm.hasButtonText &&
                                              _vm.hasButtonIcon,
                                            disabled: _vm.disabled,
                                            outline: _vm.buttonOutline
                                          },
                                          on: { click: _vm.openDialog }
                                        },
                                        "v-btn",
                                        attr,
                                        false
                                      ),
                                      [
                                        _vm.hasButtonIcon
                                          ? _c(
                                              "v-icon",
                                              { staticClass: "mr-1" },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(_vm.buttonIcon) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasButtonText
                                          ? _c("span", [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(_vm.buttonText) +
                                                  "\n            "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.hasButtonText && !_vm.hasButtonIcon
                                          ? _c("span", [
                                              _vm._v(" Select User ")
                                            ])
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _c("span", [_vm._v(" " + _vm._s(_vm.buttonTooltip))])
                ]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-layout",
                { staticClass: "align-center" },
                [
                  _c("v-flex", [
                    _c("h4", [
                      _vm._v(
                        "Select " + _vm._s(_vm.singleUser ? "a user" : "users")
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sb-modal-close",
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _vm.bodyText
                ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.bodyText))])])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", lg6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "mt-0",
                        attrs: {
                          autofocus: "",
                          label: "User name, login, email, or domain",
                          placeholder: "John Doe"
                        },
                        on: {
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.userSearch($event)
                          }
                        },
                        model: {
                          value: _vm.userSearchValue,
                          callback: function($$v) {
                            _vm.userSearchValue = $$v
                          },
                          expression: "userSearchValue"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "select-user-table mb-3" },
                [
                  _c("sphere-table", {
                    key: _vm.refreshTable,
                    ref: "userTable",
                    attrs: {
                      "non-downloadable": "",
                      "configurable-table-key": "user-select-modal-results",
                      "data-items": _vm.apiSearchValue ? undefined : [],
                      "api-endpoint": _vm.assetReviewStep
                        ? _vm.apiSearchValue
                          ? "/CommonApi/AllUserSearch?name=" +
                            _vm.apiSearchValue
                          : "/CommonApi/AllUserSearch"
                        : _vm.apiSearchValue
                        ? "/CommonApi/UserSearch?name=" + _vm.apiSearchValue
                        : "/CommonApi/UserSearch",
                      columns: _vm.columns,
                      "single-select": _vm.singleUser,
                      "table-type": "actionable",
                      name: "Selecting a user",
                      "page-length": 5,
                      "update-data-items": _vm.updateDataItems
                    },
                    on: { selectionchange: _vm.usersSelectionChange },
                    scopedSlots: _vm._u([
                      {
                        key: "noRecordsMsg",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "v-alert sb_NoDataAvialable info"
                              },
                              [
                                _c("v-icon", [_vm._v(" info ")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "warning-message" }, [
                                  _vm._v(
                                    "\n                This search did not return any users!\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("below-table"),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  staticClass: "full_width",
                  attrs: { wrap: "", row: "", "text-xs-right": "" }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { lg12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "sb-btn-outline-neutral ma-0",
                          attrs: { depressed: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "sb-btn-primary my-0",
                          attrs: {
                            depressed: "",
                            disabled: _vm.disableConfirmBtn
                              ? true
                              : _vm.requireSelection
                              ? _vm.selectedItems.length === 0
                              : false
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirm(_vm.selectedItems)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.confirmBtnText(_vm.selectedItems)) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }